export const getChatContainer = (disableSecuredStyles = false) =>
  disableSecuredStyles
    ? document.querySelector('.chat-container')
    : document.querySelector('.shadow-dom')?.shadowRoot;
